import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {Helper} from '../../../../helpers/helper.service';
import {Router} from '@angular/router';
import {DownloadService} from '../../../../back-office/Services/download.service';
import {HttpParams} from '@angular/common/http';
import {Download} from '../../../../back-office/Models/Download';
import {environment} from '../../../../../environments/environment';
import * as _ from 'lodash';
import {FileManager} from '../../../../shared/Models/FileManager';

@Component({
  selector: 'app-downloads-overview',
  templateUrl: './downloads-overview.component.html',
  styleUrls: ['./downloads-overview.component.scss']
})
export class DownloadsOverviewComponent implements OnInit {

  public downloads: Download[] = [];
  public baseURL = environment.absolutePath;
  public apiUrl = environment.apiUrl;

  constructor(
    private translate: TranslateService,
    private auth: AuthenticationService,
    private helper: Helper,
    private route: Router,
    private downloadService: DownloadService
  ) {
  }

  ngOnInit() {
    this.downloadService.getDownloads(new HttpParams(), 'dealer-system').subscribe((resp) => {
      this.downloads = resp.data;
    });
  }

  /**
   *
   * @param files
   * @return DownloadFile[]
   */
  sertFiles(files) {
    return _.sortBy(files, ['position']);
  }

  downloadFile($event: Event, file: FileManager) {
    $event.preventDefault();
    this.downloadService.downloadFile(file).subscribe();
  }
}
